import request from '@/utils/request'

// 分页查询规格模板列表
export function getSpecTemplatePage(data) {
    return request({
        url: '/admin/specTemplate/page',
        method: 'post',
        data: data
    })
}

// 获取规格模板列表（不分页）
export function getSpecTemplateList() {
    return request({
        url: '/admin/specTemplate/list',
        method: 'get'
    })
}

// 新增规格模板
export function insertSpecTemplate(data) {
    return request({
        url: '/admin/specTemplate/insert',
        method: 'post',
        data: data
    })
}

// 修改规格模板
export function updateSpecTemplate(data) {
    return request({
        url: '/admin/specTemplate/update',
        method: 'post',
        data: data
    })
}

// 删除规格模板
export function deleteSpecTemplate(id) {
    return request({
        url: '/admin/specTemplate/delete?id=' + id,
        method: 'get'
    })
}

// 获取规格值列表（根据模板ID）
export function getSpecValueList(templateId) {
    return request({
        url: '/admin/specValue/list?templateId=' + templateId,
        method: 'get'
    })
}

// 新增规格值
export function insertSpecValue(data) {
    return request({
        url: '/admin/specValue/insert',
        method: 'post',
        data: data
    })
}

// 修改规格值
export function updateSpecValue(data) {
    return request({
        url: '/admin/specValue/update',
        method: 'post',
        data: data
    })
}

// 删除规格值
export function deleteSpecValue(id) {
    return request({
        url: '/admin/specValue/delete?id=' + id,
        method: 'get'
    })
}
